import { render, staticRenderFns } from "./IdadeMediaAtivo.vue?vue&type=template&id=5962f9e6&scoped=true&"
import script from "./IdadeMediaAtivo.vue?vue&type=script&lang=js&"
export * from "./IdadeMediaAtivo.vue?vue&type=script&lang=js&"
import style0 from "./IdadeMediaAtivo.vue?vue&type=style&index=0&id=5962f9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5962f9e6",
  null
  
)

export default component.exports